import { useEffect, useRef } from "react";
import type { EditScope } from "@otrack/domain";
import { Button, Icon, Modal } from "@otrack/ui";

const CHOICES: Array<{ scope: EditScope; label: string; hint: string }> = [
  { scope: "this", label: "This event", hint: "Only this occurrence" },
  { scope: "following", label: "This and following", hint: "From here on; earlier ones stay as they are" },
  { scope: "all", label: "All events", hint: "Every occurrence in the series" }
];

/** Asks which occurrences of a repeating Event a change or deletion applies to. */
export function ScopeDialog({ verb, allowThis, onChoose }: { verb: "change" | "delete"; allowThis: boolean; onChoose: (scope: EditScope | null) => void }) {
  const firstRef = useRef<HTMLButtonElement>(null);
  useEffect(() => { firstRef.current?.focus({ preventScroll: true }); }, []);
  const choices = CHOICES.filter((choice) => allowThis || choice.scope !== "this");
  return <Modal title={verb === "delete" ? "Delete repeating event" : "Change repeating event"} icon="repeat" description={verb === "delete" ? "Which occurrences should go?" : "Which occurrences should change?"} onClose={() => onChoose(null)}>
    <div className="ot-scope">
      {choices.map((choice, index) => <button key={choice.scope} ref={index === 0 ? firstRef : undefined} type="button" className="ot-scope__choice" onClick={() => onChoose(choice.scope)}>
        <span className="ot-scope__text"><strong>{choice.label}</strong><span>{choice.hint}</span></span>
        <Icon name="arrow-right" weight="bold"/>
      </button>)}
    </div>
    <div className="ot-form__actions">
      <span className="ot-form__spacer"/>
      <Button type="button" onClick={() => onChoose(null)}>Cancel</Button>
    </div>
  </Modal>;
}
